import React from 'react'
import PropTypes from 'prop-types'
import { Trash2 } from 'lucide-react'

import { cn } from '../../../global/utils/cn.js'
import fileUtils from '../../../global/utils/fileUtils.js'
import { Button } from '../../../global/components/ui/button.jsx'
import { getFileIcon } from '../utils/fileIconUtils.jsx'

const RequestTaskFileRow = ({
  file,
  onDelete,
  draggable = false,
  onDragStart,
}) => (
  <div
    className={cn(
      'tw-mb-2 tw-flex tw-items-center tw-justify-between tw-gap-2 tw-rounded-control tw-border tw-p-2 tw-transition-colors hover:tw-bg-accent',
      draggable && 'tw-cursor-grab active:tw-cursor-grabbing',
    )}
    draggable={draggable}
    onDragStart={draggable ? onDragStart : undefined}
  >
    <div className="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-2">
      {getFileIcon(file.fileExtension)}
      <span className="tw-truncate tw-text-sm">{file.filename}</span>
      <span className="u-muted tw-shrink-0 tw-text-sm">
        ({fileUtils.formatFileSize(file.fileSize)})
      </span>
    </div>
    <Button
      variant="ghost"
      size="icon-sm"
      aria-label={`Remove ${file.filename}`}
      onClick={onDelete}
    >
      <Trash2 aria-hidden="true" />
    </Button>
  </div>
)

RequestTaskFileRow.propTypes = {
  file: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  draggable: PropTypes.bool,
  onDragStart: PropTypes.func,
}

export default RequestTaskFileRow
